import React, { useState, useEffect } from "react";
import { environment } from "../../environment";
import axios from "axios";
import { Button, Modal } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import NavbarNew from "../Components/NavbarNew";
const { SearchBar } = Search;

const MySwal = withReactContent(Swal);

const Partners = () => {
  const [Partners, setPartners] = useState([]);
  const [partnerCount, setPartnerCount] = useState("");
  const [partnerDetails, setPartnerDetails] = useState({});
  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);
  const handleClose = () => {
    setShow(false);
  };
  useEffect(() => {
    axios
      .get(environment.dap_url + "partnerApi/getAll")
      .then((res) => {
        console.log("response");
        console.log(res);
        setPartners(res.data.reverse());
        setPartnerCount(res.data.length);
        // console.log(res.data.length);
      })
      .catch((err) => {
        MySwal.fire({
          title: "Error in retriving device.",
          icon: "warning",
        });
      });
  }, []);

  const deleteHandler = (id) => {
    console.log(id);
    MySwal.fire({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
    }).then(function (result) {
      if (result.isConfirmed) {
        axios
          .delete(environment.dap_url + "partnerApi/deleteById?userId=" + id)
          .then((res) => {
            // console.log(res.data.data);
            MySwal.fire({
              title: <p>Partner has been successfully deleted!</p>,
              type: "success",
            });
            window.location.reload();
            // history.push("/Partners");
          })
          .catch((err) => {
            MySwal.fire({
              title: (
                <p>
                  {err?.response?.data?.message || "Partner deletion failed"}
                </p>
              ),
              type: "error",
            });
          });
      }
    });
  };

  const getPartnerDetail = (id) => {
    axios
      .get(environment.dap_url + "users/getUserById?id=" + id)
      .then((resp) => {
        console.log(resp);
        setPartnerDetails(resp.data.note);
        setShow(true);
      })
      .catch((err) => {
        console.log("err in fetching the users details");
      });
  };
  const formatDate = (date) => {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  };

  const columns = [
    {
      dataField: "id",
      text: "#",
      sort: false,
      formatter: (cell, row, rowIndex, formatExtraData) => {
        return rowIndex + 1;
      },
    },
    {
      dataField: "email",
      text: "Email",
      sort: true,
    },
    {
      dataField: "userFirstName",
      text: "Name",
      sort: true,
    },
    // {
    //   dataField: "userLastName",
    //   text: "LastName",
    //   sort: true,
    // },

    {
      dataField: "phone",
      text: "Phone",
      sort: true,
    },
    {
      dataField: "country",
      text: "Country",
      sort: true,
    },
    {
      dataField: "state",
      text: "State",
      sort: true,
    },
    {
      dataField: "city",
      text: "City",
      sort: true,
    },

    {
      dataField: "address",
      text: "Address",
      sort: true,
    },

    {
      dataField: "_id",
      text: "Action",
      sort: false,
      formatter: (dataField) => {
        return (
          <div>
            <Button
              variant="primary"
              className="btn-sm"
              onClick={() => getPartnerDetail(dataField)}
            >
              <i className="fa fa-eye"></i>
            </Button>
            <Button
              variant="danger"
              className="btn-sm"
              onClick={() => deleteHandler(dataField)}
            >
              <i className="fa fa-trash"></i>
            </Button>
          </div>
        );
      },
    },
  ];

  const defaultSorted = [
    {
      dataField: "id",
      order: "desc",
    },
  ];

  return (
    <div className="container-fluid">
      <NavbarNew />
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>
            {partnerDetails.userFirstName + " " + partnerDetails.userLastName}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <table class="table table-bordered">
            <tbody>
              <tr>
                <th width="50%" scope="row">
                  Name
                </th>
                <td>
                  {partnerDetails.userFirstName +
                    " " +
                    partnerDetails.userLastName}
                </td>
              </tr>
              <tr>
                <th width="50%" scope="row">
                  Email
                </th>
                <td>{partnerDetails.email}</td>
              </tr>
              <tr>
                <th width="50%" scope="row">
                  DOB
                </th>
                <td>{partnerDetails.DOB}</td>
              </tr>
              <tr>
                <th width="50%" scope="row">
                  Phone
                </th>
                <td>{partnerDetails.phone}</td>
              </tr>
              <tr>
                <th width="50%" scope="row">
                  Country
                </th>
                <td>{partnerDetails.country}</td>
              </tr>
              <tr>
                <th width="50%" scope="row">
                  State
                </th>
                <td>{partnerDetails.state}</td>
              </tr>
              <tr>
                <th width="50%" scope="row">
                  City
                </th>
                <td>{partnerDetails.city}</td>
              </tr>
              <tr>
                <th width="50%" scope="row">
                  Zip Code
                </th>
                <td>{partnerDetails.zip}</td>
              </tr>
              <tr>
                <th width="50%" scope="row">
                  Address
                </th>
                <td>{partnerDetails.address}</td>
              </tr>
              <tr>
                <th width="50%" scope="row">
                  Created_On
                </th>
                <td>{formatDate(partnerDetails.createdAt)}</td>
              </tr>
            </tbody>
          </table>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      <div>
        <h4 className="card-title">Partners</h4>

        <div className="col-12">
          {/* <h4 className="card-title" style={{ radius: "8px" }}>
                  Partners
                </h4> */}

          <ToolkitProvider
            keyField="id"
            bootstrap4
            data={Partners}
            columns={columns}
            search
          >
            {(props) => (
              <div>
                <div className="d-flex align-items-center">
                  <p className="mb-2 mr-2">Search in table:</p>
                  <SearchBar {...props.searchProps} />
                </div>
                <BootstrapTable
                  defaultSorted={defaultSorted}
                  pagination={paginationFactory()}
                  {...props.baseProps}
                  wrapperClasses="table-responsive"
                />
              </div>
            )}
          </ToolkitProvider>
        </div>
      </div>

      {/* <h5 style={{ marginLeft: "5%" }}>
        Total Number of Entries: {partnerCount}
      </h5> */}
    </div>
  );
};

export default Partners;
